import React, { useCallback } from 'react'
import classNames from 'classnames'

import LowerRound from '../index'
import { DOUBLE_ELIMINATION_TYPE, GRAND_FINAL_TYPE } from '../../constants'
import { useGetTeamName } from '../../hooks'
import {
  getArrayPairs,
  getArrayFours,
  getScore,
  getClassScoreNew,
  createPlaceholderDataDesktop,
} from '../../utils'

import s from './styles.module.scss'

const DesktopPlayOff = ({
  data,
  grandFinal,
  tournamentMember,
  isAllowRoundUpdate,
  setOpenRoundChange,
  openRoundChange,
  setTimeRound,
  setRoudnId,
  setMatchItem,
  setOpenBracketModal,
  openBracketModal,
  nextMatchId,
  nextLoserMatchId,
  setMatchId,
  winnerMatchRef,
  loserMatchRef,
}) => {
  const getTeamName = useGetTeamName(tournamentMember)

  const getClassRow = useCallback((selectRow, selectRowIndex) => {
    if (!selectRow[selectRowIndex - 1]) {
      return s.play_offRoundRowCenter
    }

    if (
      selectRowIndex &&
      selectRow[selectRowIndex - 1]?.rows?.length ===
        selectRow[selectRowIndex]?.rows?.length * 2
    ) {
      return s.play_offRoundRow
    }

    return s.play_offRoundRowCenter
  }, [])

  const getStyleBorder = useCallback((basketItem, cols, index) => {
    if (
      basketItem[index - 1]?.rows?.length >=
        basketItem[index]?.rows?.length * 2 &&
      basketItem[index - 2]?.rows?.length >=
        basketItem[index - 1]?.rows?.length * 2 &&
      basketItem[index]?.rows?.length > 2
    ) {
      return s.borderTeamFullHeight
    }

    return s.borderTeam
  }, [])

  if (!data?.basket?.length) {
    return null
  }

  return (
    <>
      {data?.basket?.length &&
        data?.basket[0]?.cols &&
        [data?.basket[0]].map((basketItem, index) => (
          <div
            className={s.play_offFlexContainer}
            key={`basket-item-${basketItem.type}-${index}`}
          >
            {basketItem?.type !== GRAND_FINAL_TYPE &&
              basketItem?.cols?.map((colsItem, i) => (
                <React.Fragment key={`cols-fragment-${basketItem.type}-${i}`}>
                  {colsItem?.rows?.length || basketItem?.type !== 'fiction' ? (
                    <div
                      className={
                        colsItem.isFiction
                          ? s.play_offRoundRowCenterFiction
                          : getClassRow(basketItem?.cols, i)
                      }
                    >
                      <div
                        className={s.roundTitle}
                        onClick={() => {
                          isAllowRoundUpdate &&
                            setOpenRoundChange(!openRoundChange)
                          setTimeRound(
                            colsItem?.rows[0]?.round?.startedAt,
                            colsItem?.rows[0]?.round?.mode
                          )
                          setRoudnId(colsItem?.rows[0]?.round?.id)
                        }}
                      >
                        {colsItem?.roundName}
                      </div>
                      {getArrayFours(
                        createPlaceholderDataDesktop(colsItem)
                      )?.map((el, index) => (
                        <div
                          className={classNames(
                            'teamsBlockBordersAndBg',
                            colsItem?.rows.length > 2
                              ? s.teamsBlock
                              : s.teamsBlock_forOne
                          )}
                          key={`item-teams-${index}`}
                        >
                          <div
                            className={getStyleBorder(
                              basketItem?.cols,
                              colsItem,
                              i
                            )}
                          />

                          {getArrayPairs(el)?.map((teamItem, index) => (
                            <div
                              onClick={() =>
                                teamItem[0]?.matchId &&
                                setMatchItem(teamItem[0])
                              }
                              key={`${basketItem.type}-pairs-${index}`}
                              className={classNames(
                                'teamBlockBg',
                                teamItem.length > 1
                                  ? s.teamBlock
                                  : s.teamBlock_forOne
                              )}
                            >
                              {teamItem?.map((block, iBlock) => (
                                <div key={`pairs-item-${block?.id}-${iBlock}`}>
                                  <div className={s.matchNumber}>
                                    {block?.id}
                                  </div>
                                  <div
                                    ref={
                                      nextMatchId === teamItem[0]?.matchId
                                        ? winnerMatchRef
                                        : null
                                    }
                                    style={
                                      nextMatchId === teamItem[0]?.matchId
                                        ? {
                                            backgroundColor: '#755f33',
                                          }
                                        : {}
                                    }
                                    className={classNames(
                                      'playerInfoBgAndBorder',
                                      s.player
                                    )}
                                    onClick={() => {
                                      setOpenBracketModal(!openBracketModal)
                                    }}
                                  >
                                    <span className={s.playerTitle}>
                                      {getTeamName(block)}
                                    </span>
                                    <div
                                      className={classNames(
                                        s.playerPont,
                                        getClassScoreNew(
                                          teamItem,
                                          block,
                                          s.playerPont_orange
                                        )
                                      )}
                                    >
                                      {getScore(block)}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className={s.play_offRoundRowCenterFiction}>
                      <div className={s.teamsBlockOneFiction} />
                    </div>
                  )}
                </React.Fragment>
              ))}
          </div>
        ))}
      {data?.basket?.length > 1 && (
        <LowerRound
          data={data?.basket[1]}
          tournamentMember={tournamentMember}
          nextMatchId={nextMatchId}
          nextLoserMatchId={nextLoserMatchId}
          setMatchId={setMatchId}
          setMatchItem={setMatchItem}
          setOpenBracketModal={setOpenBracketModal}
          openBracketModal={openBracketModal}
          winnerMatchRef={winnerMatchRef}
          loserMatchRef={loserMatchRef}
        />
      )}
      {!!(
        grandFinal &&
        data?.basket?.length &&
        data?.type === DOUBLE_ELIMINATION_TYPE
      ) && (
        <div className={s.play_offRoundRow2}>
          <div
            className={s.roundTitle}
          >{`${grandFinal?.cols[0]?.roundName}`}</div>
          <div className={classNames('teamBlockBg', s.teamBlock2)}>
            <div className={s.matchNumber}></div>
            {grandFinal?.cols[0]?.rows?.map((grandItem, index) => (
              <div
                style={
                  nextMatchId === grandItem?.matchId
                    ? {
                        backgroundColor: '#755f33',
                      }
                    : {}
                }
                onClick={() => {
                  setMatchItem(grandItem)
                  setOpenBracketModal(!openBracketModal)
                }}
                ref={nextMatchId === grandItem?.matchId ? winnerMatchRef : null}
                className={classNames('playerInfoBgAndBorder', s.player)}
                key={`grandItem-${grandItem?.matchId}-${index}`}
              >
                <span className={s.playerTitle}>{getTeamName(grandItem)}</span>
                <div
                  className={classNames(
                    s.playerPont,
                    getClassScoreNew(
                      grandFinal?.cols[0]?.rows,
                      grandItem,
                      s.playerPont_orange
                    )
                  )}
                >
                  {getScore(grandItem)}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  )
}

export default React.memo(DesktopPlayOff)
